import CollectRecordsCount from './CollectRecordsCount'

export default CollectRecordsCount
